<form class="k-form k-form-sm" [formGroup]="form">
  <formly-form
    [form]="form"
    [fields]="(formlyFormConfig | async).fields"
    [model]="formModel"
  ></formly-form>
</form>
